// Dependencies
import React from 'react';

import { RentVsBuyInput } from '../../../../../lib/utils';
import RentAppreciationInput from '../rent-appreciation';

const RentAppreciationInputWithAnalytics: React.FC<RentVsBuyInput> = ({
  label,
  tooltip,
  className,
  fullWidth,
}) => {
  return (
    <RentAppreciationInput
      label={label}
      tooltip={tooltip}
      className={className}
      fullWidth={fullWidth}
    />
  );
};

export default RentAppreciationInputWithAnalytics;
